import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { HERO } from '../constants/testIds';

const Hero = () => {
  const scrollToCafe = () => {
    const element = document.getElementById('cafe');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  return (
    <section 
      data-testid={HERO.section}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-[#142A1D]"
    >
      {/* Video Background - solid dark background beneath video prevents any flash of unstyled content */}
      <video
        data-testid="hero-video"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover z-0"
        style={{ objectFit: 'cover', objectPosition: 'center center' }}
      >
        <source 
          src="https://customer-assets.emergentagent.com/job_legatum-coffee/artifacts/qnq0d8tb_video%20nuevo.mp4" 
          type="video/mp4" 
        />
      </video>
      
      {/* Animated Overlay */}
      <motion.div 
        className="absolute inset-0 z-[1] pointer-events-none"
        initial={{ opacity: 0.3 }}
        animate={{ opacity: 0.55 }}
        transition={{ duration: 1.5 }}
        style={{
          background: 'linear-gradient(to bottom, rgba(20, 42, 29, 0.5), rgba(20, 42, 29, 0.7))'
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <motion.p 
          data-testid={HERO.subtitle}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-[#F2EBE1] uppercase tracking-[0.3em] text-sm md:text-base mb-10 font-light"
        >
          Productores de Café de Especialidad
        </motion.p>
        
        <motion.div 
          data-testid={HERO.title}
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1.2, delay: 0.4, ease: "easeOut" }}
          className="mb-8 flex justify-center"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_legatum-coffee/artifacts/dumgss85_LOGO2.webp"
            alt="Legatum Coffee"
            className="w-full max-w-md md:max-w-xl lg:max-w-2xl h-auto drop-shadow-2xl"
          />
        </motion.div>
        
        <motion.p 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-[#F2EBE1] text-lg md:text-xl mb-14 max-w-2xl mx-auto font-light drop-shadow-lg italic"
        >
          Del corazón del Huila, Colombia
        </motion.p>
        
        <motion.button
          data-testid={HERO.ctaButton}
          onClick={scrollToCafe}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.8 }}
          whileHover={{ scale: 1.05, y: -3 }}
          whileTap={{ scale: 0.95 }}
          className="btn-primary text-base px-12 py-5 inline-block shadow-2xl"
        >
          Descubrir Nuestro Café
        </motion.button>
      </div>
      
      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
        className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="flex flex-col items-center gap-2 cursor-pointer"
          onClick={scrollToCafe}
        >
          <span className="text-white text-sm uppercase tracking-wider opacity-70 drop-shadow-lg">Scroll</span>
          <ChevronDown className="w-6 h-6 text-white opacity-70 drop-shadow-lg" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
